module.exports = __webpack_public_path__ + "img/massage.72da2809.jpg";